import React from 'react';
import BaseAreaStack from './private/BaseAreaStack';
export default function AreaStack(props) {
  return /*#__PURE__*/React.createElement(BaseAreaStack, props);
}